<template>
  <div
    v-click-outside="close"
    class="image-box-with-options"
  >
    <div
      class="image-box-with-options__button"
      :class="{ 'image-box-with-options--active': isOpen }"
      @click="open"
    >
      <slot name="icon">
        <base-icon
          v-if="icon"
          :icon="icon"
          class="mr-2"
        />
      </slot>
      <div>{{ title }}</div>
      <base-icon
        icon="arrow-right-little"
        class="image-box-with-options__icon ml-auto"
      />
    </div>
    <transition name="fade">
      <div
        v-if="isOpen"
        class="image-box-with-options__submenu"
        :style="submenuStyles"
      >
        <slot :is-open="isOpen" />
      </div>
    </transition>
  </div>
</template>

<script>
/**
 * This component is a button with a tooltip
 * It's used on the collage to display options in horizontal and vertical
 *
 */
export default {
  name: 'ImageBoxToolWithOptions',

  props: {
    title: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    align: {
      type: String,
      default: '',
    },
    shadow: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    submenuStyles() {
      if (this.align === 'top') {
        return {
          top: 0,
        };
      }

      if (this.align === 'bottom') {
        return {
          bottom: 0,
        };
      }

      return {};
    },
  },
  mounted() {},
  methods: {
    open() {
      this.isOpen = true;
    },
    close() {
      this.isOpen = false;
    },
  },
};
</script>
<style lang="scss">
</style>
<style lang="scss" scoped>
.image-box-with-options {
  position: relative;

  &__submenu {
    font-family: $font-family-sans-serif-light;
    background: $gray-light;
    z-index: 1041;
    border-radius: 8px;
    transform: translateX(calc(100% + 8px));
    position: absolute;
    // top: 0;
    padding: 0.5rem 0;
    border-top-left-radius: 0px;
    box-shadow: 0 4px 10px rgba(#333333, 0.1);
    right: -12px;
  }
    /** Use class `.image-box__option` and `.image-box__option--selected` in items inside v-slot */
  &::v-deep .image-box__option {
    height: 30px;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    margin-left: 0.5rem;
    margin-right: 0.5rem;
    white-space: nowrap;
    display: flex;
    align-items: center;
    cursor: pointer;
    touch-action: manipulation;
    &--selected, .--selected {
      border: solid 1px $clementine;
      border-radius: 3px;
    }
  }

  &__button {
    color: $black;
    background: none;
    border: none;
    padding: 0.75rem 0.5rem;
    height: 46px;
    display: flex;
    align-items: center;
    touch-action: manipulation;
    cursor: pointer;
    white-space: nowrap;

    &:hover {
      opacity: 1;
      background-color: #f2f1ee;
    }

    &--active {
      opacity: 1;
    }

    &--disabled {
      pointer-events: none;
      opacity: 0.1;
    }

    &--color {
      padding: 0;
    }
  }
}

/** Vertical version - This is related to its parent `.image-box-tools` */
.image-box-tools .image-box-with-options {
  transition: background 0.2s;
  &--active {
    background-color: $gray-light-5;
  }

  &__icon {
    display: none;
  }
  // Submenu
  &__submenu {
    transform: translateX(0);
    bottom: calc(100% + 8px);
    left: 0;
    right: inherit;
    top: inherit;
    border-top-left-radius: 8px;
    box-shadow: 0 4px 10px rgba(#333333, 0.1);
    min-width: 100px;
  }
}

// Transition
.fade-enter-active,
.fade-leave-active {
  transition: all 0.15s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
